import { useState, useEffect, useContext } from 'react'
import { FeathersContext } from '@strac/react-client-feathers'

// Our hook
export default function useServerConnected() {
  const { client } = useContext(FeathersContext)

  const [connected, setServerConnection] = useState<boolean>(false)

  useEffect(() => {
    const socketConnected = client?.io?.connected || false
    setServerConnection(socketConnected)
    // if (socketConnected !== connected) setServerConnection(socketConnected);

    const connectionListener = () => {
      setServerConnection(true)
    }

    const disconnectionListener = () => {
      setServerConnection(false)
    }

    client?.io?.on('connect', connectionListener)
    client?.io?.on('disconnect', disconnectionListener)

    return () => {
      client?.io?.off('connect', connectionListener)
      client?.io?.off('disconnect', disconnectionListener)
    }
  }, [client])

  return connected
}
